import React, { Component } from 'react';
import PropTypes from 'prop-types';

import toString from 'lodash/toString';

import { SuiAutocompleteInput } from '@splashthat/sui';

const MIN_FONT_SIZE = 8;
const MAX_FONT_SIZE = 32;

const FONT_SIZE_LIST = [MIN_FONT_SIZE, 12, 16, 20, 24, 28, MAX_FONT_SIZE].map((fontSize) => ({
    value: fontSize,
    label: toString(fontSize),
}));

const BASE_CLASS_NAME = 'FontSizePicker';

export default class FontSizePicker extends Component {
    static propTypes = {
        fontSizeList: PropTypes.arrayOf(PropTypes.number),
        defaultFontSize: PropTypes.number.isRequired,
        activeFontSize: PropTypes.number,
        onChangeFontSize: PropTypes.func.isRequired,
        qaId: PropTypes.string.isRequired,
        'aria-label': PropTypes.string,
    };

    static defaultProps = {
        fontSizeList: [],
        activeFontSize: undefined,
        'aria-label': undefined,
    };

    handleOnInputChange = (event, { value }) => {
        const newFontSize = parseInt(value || MIN_FONT_SIZE, 10);
        this.props.onChangeFontSize(newFontSize);
    };

    render() {
        const { defaultFontSize, activeFontSize, qaId, 'aria-label': ariaLabel } = this.props;
        const min = Math.min(this.props.fontSizeList);
        const max = Math.max(this.props.fontSizeList);
        const suggestionValues = this.props.fontSizeList.length
            ? this.props.fontSizeList.map((fontSize) => ({
                  value: fontSize,
                  label: toString(fontSize),
              }))
            : FONT_SIZE_LIST;

        const defaultValue = defaultFontSize
            ? {
                  value: defaultFontSize,
                  label: defaultFontSize.toString(),
              }
            : null;

        const value = activeFontSize
            ? {
                  value: activeFontSize,
                  label: activeFontSize.toString(),
              }
            : null;

        return (
            <div data-qa={qaId} className={`${BASE_CLASS_NAME}__data-container`}>
                <SuiAutocompleteInput
                    fullWidth
                    className={`${BASE_CLASS_NAME}__container`}
                    suggestionValues={suggestionValues}
                    defaultValue={defaultValue}
                    value={value}
                    type="number"
                    min={min || MIN_FONT_SIZE}
                    max={max || MAX_FONT_SIZE}
                    onChange={this.handleOnInputChange}
                    preventSuggestions
                    aria-label={ariaLabel}
                />
            </div>
        );
    }
}
